import { apiFunction } from "../../apiCall/function"

export const updateAllotment = async (id) => {
  let data = {
    allotment_id: id
  }
  return await apiFunction("form/allotment-mail", "post", data, true, 'body')
}